var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 514,
    width: 514,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#B43434",
    strokeWidth: 34,
    transform: "translate(-45 -45)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 190,
    rx: 95,
    transform: "rotate(-45 195.64 408.527)",
    width: 294,
    x: 48.64,
    y: 313.527
  }), /*#__PURE__*/React.createElement("rect", {
    height: 190,
    rx: 95,
    transform: "rotate(-45 408.161 195.161)",
    width: 294,
    x: 261.161,
    y: 100.161
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221 381 161-159",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.81b1435005e6fa34d2223399380a0c02.svg";
export { ForwardRef as ReactComponent };